import { render, staticRenderFns } from "./addDataForm.vue?vue&type=template&id=578110f2&"
import script from "./addDataForm.vue?vue&type=script&lang=js&"
export * from "./addDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports